import { InjectionToken } from '@angular/core';
import { NavigationExtras } from '@angular/router';
import { ShareableType } from '@bindoc-projects/resource-domain-lib';

/**
 * A router navigation target for a shareable's detail page: the router
 * `commands` array plus optional `extras` (e.g. `queryParams`).
 */
export interface ShareableDetailLink {
  commands: unknown[];
  extras?: NavigationExtras;
}

/**
 * Builds the navigation target used to open a single resource of a given
 * `ShareableType`. Receives the resource id and returns the router commands
 * (and optional extras).
 *
 * Keeping the full routing shape at the registration call site means every
 * layout is just a different return value — id appended last
 * (`['/markets', id]`), id in the middle
 * (`['/virtual-clinic-referral', 'import', id]`), or id
 * as a query param (`{ commands: [...], extras: { queryParams: { … } } }`) —
 * with no per-shape configuration flags.
 */
export type ShareableDetailRoute = (id: string) => ShareableDetailLink;

export type ShareableDetailRoutes = ReadonlyMap<
  ShareableType,
  ShareableDetailRoute
>;

export const BD_SHAREABLE_DETAIL_ROUTES =
  new InjectionToken<ShareableDetailRoutes>('BD_SHAREABLE_DETAIL_ROUTES');
